import axios from 'axios';

// Configuración base de Axios con la nueva URL de Flask
const apiClient = axios.create({
  baseURL: 'https://dam.toolia.site', // Nueva URL del backend
  headers: {
    'Content-Type': 'application/json',
  },
});

// Función para registrar usuarios con el nuevo endpoint
export const registerUser = async (userData) => {
  try {
    console.log('Enviando datos de usuario:', userData); // Log para depuración
    const response = await apiClient.post('/save-user', userData);
    console.log('Respuesta del servidor:', response.data); // Log para depuración
    
    if (!response.data.user_id || !response.data.session_id) {
      throw new Error('Respuesta del servidor incompleta: faltan user_id o session_id');
    }
    
    return response.data; // Devuelve user_id y session_id
  } catch (error) {
    console.error('Error al registrar usuario:', error.message);
    throw error;
  }
};

export default apiClient;
